export default {
  methods: {
    /**
     * @param {object} response
     * @param {object|null} messenger
     * @return {boolean}
     */
    handleErrorResponse({response: {data, status}}, messenger = null) {
      messenger = messenger || this.$message;
      let {message} = data || {};
      if (status === 401 && !message) {
        message = 'Not Authenticated';
      }
      if (message) {
        messenger.error(message);
      }
    },
  }
}
